/**
 * User Service
 * Skeleton admin user management service.
 *
 * This class is intentionally minimal for now and will be expanded with
 * admin-only user CRUD operations once the backend endpoints are finalized.
 */

import { CrudService } from './crud.service';

import type { User } from '../types/auth';

// =============================================================================
// USER SERVICE CLASS
// =============================================================================

/**
 * Admin-facing user management service.
 *
 * NOTE: This is currently a placeholder and should not be used in
 * production flows until the admin user API is implemented.
 */
export class UserService extends CrudService<User> {
  constructor() {
    super({
      // todo: update this baseUrl when admin user endpoints are available
      baseUrl: '/admin/user',
      enableCaching: true,
      cacheTTL: 10 * 60 * 1000, // 10 minutes
    });
  }

  // ---------------------------------------------------------------------------
  // OVERRIDE METHODS FROM CRUD SERVICE
  // ---------------------------------------------------------------------------

  /**
   * Transform user data before sending to API
   */
  protected override transformRequest(data: Partial<User>): Partial<User> {
    // Remove read-only fields
    const { id, createdAt, updatedAt, ...validData } = data as Record<
      string,
      unknown
    >;

    // Explicitly ignore unused destructured variables
    void id;
    void createdAt;
    void updatedAt;

    return validData as Partial<User>;
  }

  /**
   * Validate user data before operations
   */
  protected override validateData(_data: Partial<User>): void {
    // todo: validate user data
  }
}

// =============================================================================
// SERVICE INSTANCE AND FACTORY
// =============================================================================

export const userService = new UserService();

/**
 * Create a new user service instance with custom configuration
 */
export const createUserService = (): UserService => {
  return new UserService();
};
